// @flow
import React, { Fragment, type Node } from 'react';

import { Button } from 'Components/frameworks/button/Button.jsx';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';
import { TextLink } from 'Components/frameworks/text-link/TextLink.jsx';

type Props = {
  acceptCookies: () => *,
  approveAriaLabel: string,
  buttonLabel: string,
  cookieKey: string,
  dataSelector: string,
  link: { url: string, label: string },
  openLayer: () => *,
  openLayerLabel: string,
  text: string,
  title: string,
};

const CookieWarningBanner = ({
  acceptCookies,
  approveAriaLabel,
  buttonLabel,
  cookieKey,
  dataSelector,
  link,
  openLayer,
  openLayerLabel,
  text,
  title,
}: Props): Node => (
  <Fragment>
    <section className="bg-white fixed bottom-0 shadow w-full z-6">
      <SiteContainer>
        <div className="flex flex-col sm:flex-row sm:items-center py-2">
          <div className="p-2">
            {!!title && (
              <h3 className="reset-heading font-bold font-sans leading-tight mb-1 text-gray-darker text-md sm:text-lg">
                {title}
              </h3>
            )}
            <Text
              className="font-sans leading-normal mb-1 text-gray-darker text-sm sm:text-base"
              text={text}
            />
            {!!link.label && (
              <p className="font-bold font-sans leading-normal mb-1 mt-0 text-gray-darker text-sm sm:text-base">
                <DynamicLink
                  className="no-underline text-gray-darker"
                  target="_blank"
                  url={link.url}
                >
                  {link.label}
                </DynamicLink>
              </p>
            )}
          </div>
          <div className="flex-shrink-0 p-2 text-center sm:w-1/5 sm:max-w-xs">
            <Button ariaLabel={approveAriaLabel} className="w-full" onClick={acceptCookies}>
              {buttonLabel}
            </Button>
            <TextLink className="mt-4" isUppercase label={openLayerLabel} onClick={openLayer} />
          </div>
        </div>
      </SiteContainer>
    </section>
    <script
      dangerouslySetInnerHTML={{
        __html: `
        var banner = document.querySelector("div[data-selector='${dataSelector}']");

        if (banner && document && document.cookie.match(/${cookieKey}=1/)) {
          console.log('hide')
          banner.style.display = "none";
        }
      `,
      }}
    />
  </Fragment>
);

export default CookieWarningBanner;
